import axios from "axios";

const buscarConveniosAPI = async function (estadoid) {
  let orgaos = {}

  try {
      await axios({
        method: 'get',
        url: process.env.VUE_APP_ALIANCAADM_WP + `/aliancaheadless/v1/conveniosbyestadoid/${estadoid}`
      }).then(response =>{
        orgaos = response.data
      })
      .catch(error => {
        orgaos = undefined
        console.log(error)
      })
  } catch (e) {
    console.log(e)
  }

  return orgaos
};

export default buscarConveniosAPI;
